import { REFERENCED_USER_SEARCH_FILTER_TYPE } from "search-filter/constants";
const isFilterInaccessible = (filter, isPermitted) => filter.type === REFERENCED_USER_SEARCH_FILTER_TYPE && !isPermitted([`search_filters:read:${filter.id}`]);
export default isFilterInaccessible;
